import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "8u" }
const _hoisted_2 = { class: "4u" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "gratis route", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_TrailReactions = _resolveComponent("TrailReactions")!
  const _component_TrailMenu = _resolveComponent("TrailMenu")!
  const _component_TrailInformation = _resolveComponent("TrailInformation")!
  const _component_TrailUnAuthorizedOptions = _resolveComponent("TrailUnAuthorizedOptions")!
  const _component_ModalMessage = _resolveComponent("ModalMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view),
      (_ctx.currentTrail.reactions)
        ? (_openBlock(), _createBlock(_component_TrailReactions, {
            key: 0,
            reactions: _ctx.currentTrail.reactions
          }, null, 8, ["reactions"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TrailMenu, {
        trail: _ctx.currentTrail,
        onBtnClick: _ctx.toggleShowNotLoggedIn
      }, null, 8, ["trail", "onBtnClick"]),
      _createVNode(_component_TrailInformation, { trail: _ctx.currentTrail }, null, 8, ["trail"])
    ]),
    (_ctx.showNotLoggedIn)
      ? (_openBlock(), _createBlock(_component_ModalMessage, {
          key: 0,
          modalClass: "mrbox darkfill border darkfill",
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNotLoggedIn = false)),
          class: "TrailUnAuthorizedOptionsmodel"
        }, {
          header: _withCtx(() => [
            _hoisted_3
          ]),
          body: _withCtx(() => [
            _createVNode(_component_TrailUnAuthorizedOptions, { trail: _ctx.currentTrail }, null, 8, ["trail"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}